import { render, staticRenderFns } from "./AppProductsCard.vue?vue&type=template&id=4208920d"
import script from "./AppProductsCard.vue?vue&type=script&lang=js"
export * from "./AppProductsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports